import React from 'react'
import styled from '@emotion/styled'

import { IconButton } from '@mui/material'
import { Person as PersonIcon } from '@mui/icons-material'

import UserSettingsMenu from '../UserSettingsMenu'

const BtnContainer = styled.div``

interface Props {
    auctionPickerOpenRequest?: number
    disabled: boolean
}
const UserAvatar: React.FC<Props> = ({ auctionPickerOpenRequest, disabled }: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>()
    const [menuOpen, setMenuOpen] = React.useState(false)
    const buttonRef = React.useRef<HTMLButtonElement | null>(null)
    const lastHandledOpenRequestRef = React.useRef(0)

    const handleOpen = (e: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(e.currentTarget)
        setMenuOpen(true)
    }
    const handleClose = (): void => setMenuOpen(false)

    React.useEffect(() => {
        if (!auctionPickerOpenRequest || auctionPickerOpenRequest === lastHandledOpenRequestRef.current || disabled) {
            return
        }

        lastHandledOpenRequestRef.current = auctionPickerOpenRequest

        if (!buttonRef.current) {
            return
        }

        setAnchorEl(buttonRef.current)
        setMenuOpen(true)
    }, [auctionPickerOpenRequest, disabled])

    return (
        <BtnContainer>
            <IconButton ref={buttonRef} edge="end" onClick={handleOpen} disabled={disabled}>
                <PersonIcon />
            </IconButton>
            <UserSettingsMenu
                auctionPickerOpenRequest={auctionPickerOpenRequest}
                open={menuOpen}
                handleClose={handleClose}
                anchor={anchorEl}
            />
        </BtnContainer>
    )
}

export default UserAvatar
